import React, { memo } from 'react';

import { TableExportType } from 'src/graphql';
import { useTableExport } from 'src/hooks';
import { CovenantTrackingTableRow } from 'src/types';
import { Header } from './';

type HeaderContainerProps = {
  tableExportData: {
    columns: any;
    rows: Array<CovenantTrackingTableRow>;
  };
};

const HeaderContainer = memo(({ tableExportData }: HeaderContainerProps) => {
  const [onExport, { loading: isExporting }] = useTableExport(
    TableExportType.CovenantTracking,
    tableExportData,
  );

  return <Header onExport={onExport} isExporting={isExporting} />;
});

HeaderContainer.displayName = 'HeaderContainer';

export { HeaderContainer };
